var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventEquipmentGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 6.3335C15.1917 6.3335 16.5 5.02516 16.5 3.41683C16.5 2.9335 16.3667 2.4835 16.1583 2.0835L13.9083 4.3335L12.6667 3.09183L14.9167 0.841829C14.5167 0.633496 14.0667 0.500163 13.5833 0.500163C11.975 0.500163 10.6667 1.8085 10.6667 3.41683C10.6667 3.7585 10.7333 4.0835 10.8417 4.3835L9.3 5.92516L7.81667 4.44183L8.40833 3.85016L7.23333 2.67516L9 0.908496C8.025 -0.0665039 6.44167 -0.0665039 5.46667 0.908496L2.51667 3.8585L3.69167 5.0335H1.34167L0.75 5.62516L3.7 8.57516L4.29167 7.9835V5.62516L5.46667 6.80016L6.05833 6.2085L7.54167 7.69183L1.36667 13.8668L3.13333 15.6335L12.6167 6.1585C12.9167 6.26683 13.2417 6.3335 13.5833 6.3335Z",
    fill: "#AFAFAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventEquipmentGrey);
export default __webpack_public_path__ + "static/media/event_equipment_grey.83dc8b8e15f278be32a4390cc9947484.svg";
export { ForwardRef as ReactComponent };